import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect, renderAutoCompleteScheduling, renderCheckBox, renderTextField, isValidAuthNumber } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import {getPatient} from '../../actions/index';
import history from '../../../../history';
import {getPatientListWithPermission} from '../../actions/index';
import {HasUrlAccess} from '../../actions/index';

const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

const validate = (values) => {
  const errors = {};
  
  if (!values.patientId) {
    errors.patientId = 'Please select client.';
  }
  
  return errors;
};

class AuthorizationDetailsByMonthReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,            
      patientId : 0,       
      iframeURL: '',
      isLoading: false,
      random: 0,
      isIncludeExpiredAuth: false,
      isIncludeRenderOnly: false,
    };    
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    this.checkAuth = this.checkAuth.bind(this);
    this.checkRenderedOnly = this.checkRenderedOnly.bind(this);
  }

  componentWillMount() {   
    this.props.HasUrlAccess('/reports/authorization-details-by-month-report'); 
    let searchObj = {
      locationIds: '0',
      isActiveCheckRequired: 'YES',
      viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission,
    };
    this.props.getPatientListWithPermission(searchObj);
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe(); 
    let REPORT_URL  = GetReportUrl(this.props.agencyName);       
    let reportName = base64Encode('CL_AuthorizationDetailsReport_ByMonth');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "LocationID","Value": "`+ (formData.location || 0) + `"},{"Name": "PatientIds","Value": "`+ (formData.patientIds && formData.patientIds.length > 0 ? formData.patientIds : 0) + `"},{"Name": "AuthorizationNumber","Value": "`+ (formData.authorizationNumber || 0) + `"},{"Name": "IncludeExpiredAuth","Value": "` + this.state.isIncludeExpiredAuth + `"},{"Name": "IncludeRenderOnly","Value": "` + this.state.isIncludeRenderOnly + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"},{"Name": "ViewTeamClientsOnlyPermissionForReports","Value": "` + this.props.viewTeamClientsOnlyPermission + `"},{"Name": "LoginUserId","Value": "` + this.props.loginUserID + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  } 

  checkAuth = (e, name) => {
    if (name === 'isIncludeExpiredAuth' && e.target.checked) {
      this.setState({isIncludeExpiredAuth : true});
    }
    else if (name === 'isIncludeExpiredAuth' && !e.target.checked) {
      this.setState({isIncludeExpiredAuth : false});
    } 
  }

  checkRenderedOnly = (e, name) => {
    if (name === 'isIncludeRenderOnly' && e.target.checked) {
      this.setState({isIncludeRenderOnly : true});
    }
    else if (name === 'isIncludeRenderOnly' && !e.target.checked) {
      this.setState({isIncludeRenderOnly : false});
    } 
  }

  handleChangePatient = (input, selectedRecord) => {
    //if (input.name === 'staffIds') {
      input.onChange(selectedRecord);
    //}
    // else{
    //   input.onChange(selectedRecord.value);
    //   this.props.GetStaffByLocation(selectedRecord.value, 'YES')
    // }
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  onBackClick = () => {
    history.push('/reports/scheduling-reports');
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;    
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Scheduling {' > '} Authorization Details By Month Report</h2>
        :
        <h2 className="page_title">Authorization Details By Month Report</h2>                    
        }  
        
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            {/* <div className="panel_title">
              <h7 style={styles.font}>*Scheduled and rendered hours use rounding rules in order to display actual hours remaining. </h7>                    
            </div>   */}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-4 mt-35">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleChange}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-4 require mt-35">
                    <Field
                      name="patientIds"
                      label="Client"
                      handleNewRequest={this.handleChangePatient}
                      options={this.props.patientlist}
                      component={renderAutoCompleteScheduling}
                      fullWidth={true}
                    />
                </div>
                <div className="col-sm-4">
                  <Field
                    name="authorizationNumber"
                    type="text"
                    maxLength="20"
                    normalize = {isValidAuthNumber}
                    label="Authorization Number"
                    component={renderTextField}
                  />
                </div>
                <div className="col-sm-4 mt-30">
                      <Field
                        className="mt20 mb0"
                        name="isIncludeExpiredAuth"
                        label="Include Expired Authorizations"
                        onChange={(e) => this.checkAuth(e, 'isIncludeExpiredAuth')}
                        component={renderCheckBox}
                      />
                </div>
                <div className="col-sm-4 mt-30">
                      <Field
                        className="mt20 mb0"
                        name="isIncludeRenderOnly"
                        label="Include Rendered Only"
                        onChange={(e) => this.checkRenderedOnly(e, 'isIncludeRenderOnly')}
                        component={renderCheckBox}
                      />
                </div>
                
                <div className="col-sm-4 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e)=> this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

AuthorizationDetailsByMonthReport = reduxForm({
  form: 'AuthorizationDetailsByMonthReportForm',
  validate,
  enableReinitialize: true,
})(AuthorizationDetailsByMonthReport);

function mapStateToProps(state) {
  let patients = [], locationArr = [];
  if (state.report.patientList && state.report.patientList.data) {
    patients = state.report.patientList.data.patients;
  }
  
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }
// console.log('state.report.master_data............',state.report.master_data.allStaffs)

 // Start For Role Permission

 let userScreenPermission = [];
 if (state.login.userPermission) {
   let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
   userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
 }

 let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0].permission : false;


 // End For Role Permission

  return {
    orgID: state.login.loginUserInfo.organizationID,
    patientlist: patients,
    userLocationList: locationArr,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
  };
}
export default connect(mapStateToProps, {getPatientListWithPermission, HasUrlAccess})(AuthorizationDetailsByMonthReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/SchedulingReports/AuthorizationDetailsByMonthReport.js